export const SEARCH = "search/search_bar";
export const CATEGORYSEARCH = "search/category";
export const AUTHORSEARCH = "search/author";
